import { graphql } from '../../../graphql/generated';

export const NewsListFragment = graphql(`
  fragment NewsList_News on News {
    id
    lab {
      id
      name
    }
    confirmationId
    heading
    content
    link1Href
    link1Text
    link2Href
    link2Text
    link3Href
    link3Text
    attachment1Id
    attachment1Filename
    attachment1Size
    attachment2Id
    attachment2Filename
    attachment2Size
    attachment3Id
    attachment3Filename
    attachment3Size
  }
`);
